import {
  getOperatorMissionStatus,
  getMissionOperatorPickedFleetId,
  getIsPickedFleetHasVehicles,
  getMissionOperatorFleetIdForSubscribe,
  getOperatorMissionOrder,
  getOperatorPanelOccupied,
  getIsOperatorPanelOccupiedForPickedStation,
  getInProgressFleetMissions,
  getInQueueFleetMissions,
  getFleetMissions,
  getReleasedStops,
  getIsOperatorMissionArrived,
} from "./selectors";
import OperatorDataSlice from "./reducers";

// actions
export const {
  setInitialMissionOperatorData,
  setMissionOperatorFleetId,
  resetMissionOperatorData,
  resetMissionOperatorState,
  updateMissionOperatorData,
  markStopReleased,
} = OperatorDataSlice.actions;

// selectors
export {
  getOperatorMissionStatus,
  getMissionOperatorPickedFleetId,
  getIsPickedFleetHasVehicles,
  getMissionOperatorFleetIdForSubscribe,
  getOperatorMissionOrder,
  getOperatorPanelOccupied,
  getIsOperatorPanelOccupiedForPickedStation,
  getInProgressFleetMissions,
  getInQueueFleetMissions,
  getFleetMissions,
  getReleasedStops,
  getIsOperatorMissionArrived,
};

// reducer
export default OperatorDataSlice.reducer;
